<template>
  <div>
    <div class="row" v-if="translation(15531) !== ''">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{translation(15531)}}</span>
      </div>
    </div>
    <div class="row margin20" v-if="translation(15532) !== ''">
      <div class="col-md-12">
        <p v-html="translation(15532)"></p>
      </div>
    </div>
    <membercard></membercard>
  </div>
</template>
<script>
import membercard from '@/components/membercard'
export default {
  components: {
    membercard
  }
}
</script>
<style>
</style>
